module.exports = __webpack_public_path__ + "f462aa80f75c80e423dff81ee3ca66b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/david-khourshid.jpg
// module id = 512
// module chunks = 0